module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/j48jFk/tc-custom/9781609252229.jpg?1728851724905",
      "alt": "This image is the cover for the book Community of Kindness"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Community of Kindness\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“An eloquent reminder of the great truth that life is with people and none of us can be truly human alone.” —Harold S. Kushner, author of "), _c('i', [_vm._v("When Bad Things Happen to Good People")])]), _c('br'), _c('br'), _vm._v("The world has changed in so many ways in recent decades—and as a result, meaningful connections are increasingly elusive. "), _c('i', [_vm._v("The")]), _c('i', [_vm._v("Community of Kindness")]), _vm._v(" encourages us to create new ways of building community through the practice of kindness. It is through that effort that we become most fully connected, alive, and integrated."), _c('br'), _c('br'), _vm._v("From the people who brought us "), _c('i', [_vm._v("Random Acts of Kindness")]), _vm._v(", this insightful book can not only lift your heart, but fill it with the happiness that comes from feeling a sense of connection with the world and people around us.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      The Editors of Random Acts of Kindness\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Conari Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0